var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCaretLeftCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.148,407.505a13.5,13.5,0,1,0,13.5,13.5A13.516,13.516,0,0,0,298.148,407.505Zm0,26a12.5,12.5,0,1,1,12.5-12.5A12.515,12.515,0,0,1,298.148,433.505Z",
    transform: "translate(-284.648 -407.505)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M301.248,415.112a.537.537,0,0,0-.754,0l-5.449,5.45a.6.6,0,0,0,0,.8l5.454,5.455a.537.537,0,0,0,.758,0,.541.541,0,0,0,0-.754l-5.1-5.094,5.1-5.1A.536.536,0,0,0,301.248,415.112Z",
    transform: "translate(-284.648 -407.505)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCaretLeftCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/caret-left-circle.ac61a574.svg";
export { ForwardRef as ReactComponent };